import React from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaLinkedin,
  FaYoutube
} from "react-icons/fa";
import logofooter from "../images/logoname.jpeg";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LOGO + TEXT */}
        <div
          className="footer-col"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img src={logofooter} className="logo-footer" alt="logo" />
          <p>
            Exporting premium quality Fruits, Vegetables and Spices from India
            to the world.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/products">Products</Link>
            </li>
            <li>
              <Link to="/process">Our Process</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* PRODUCTS */}
        <div className="footer-col">
          <h3>Our Products</h3>
          <ul>
            <li>
              <Link to="/products/fruits">Fruits</Link>
            </li>
            <li>
              <Link to="/products/vegetables">Vegetables</Link>
            </li>
            <li>
              <Link to="/products/spices">Spices</Link>
            </li>
          </ul>
          <Link to="/developer" className="dev-btn">
            👨‍💻 Developer Contact
          </Link>
        </div>

        {/* 👉 ADD CERTIFICATIONS HERE 👈 */}
        <div className="footer-col">
          <h3>Certifications</h3>
          <ul>
            <li>
              <Link to="/certifications?cert=gst">
                GST
              </Link>
            </li>
            <li>
              <Link to="/certifications?cert=rcmc">
                RCMC
              </Link>
            </li>
            <li>
              <Link to="/certifications?cert=iec">
                Import Export Code (IEC)
              </Link>
            </li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col footer-col-contact">
          <h3>Contact Us</h3>

          <div className="contact-container">
            <div className="contact-itemf">
              <a href="tel:+917842069778">
                <span className="icon">📞</span>
              </a>
              <p>+91 7842069778, 8497944251</p>
            </div>

            <div className="contact-itemf">
              <a href="mailto:giridhar@uniqueglobalexports.com">
                <span className="icon">📧</span>
              </a>
              <p>giridhar@uniqueglobalexports.com</p>
            </div>

            <div className="contact-itemf">
              <a
                href="https://maps.app.goo.gl/NZoLkQxi3juU54A5A?g_st=aw"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-link"
              >
                <span className="icon">📍</span>
              </a>
              <p>
                1-8-294/4/A/1, Aadarsh Nagar, Metpally, Jagityal, Telangana -
                505325, India
              </p>
            </div>
          </div>

          <div className="social-icons">
            <a
              href="https://facebook.com/61589321860253"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.youtube.com/@Uniqueglobalexports7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.instagram.com/unique_global_exports?igsh=MTd6b2s1bmhqc24xcA=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            {/* <a
              href="https://wa.me/917842069778"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a> */}
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/unique-global-exports-unique-global-exports-3ab8b6408"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Unique Global Exports. All rights reserved.
      </div>

      <style>{`
          .footer {
                background: linear-gradient(90deg, #064e3b, #065f46, #16a34a);
                color: #e5e7eb;
                padding: 70px 8% 25px;
                font-family: 'Poppins', sans-serif;
              }

              /* GRID */
              .footer-container {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 50px;
              }
                .footer-mini-text {
                font-size: 12px;
                color: rgba(255,255,255,0.7);
                margin-bottom: 14px;
                line-height: 1.5;
              }

              /* LOGO */
              .logo-footer {
                width: 190px;
                display: block;
                margin: 0 auto 20px;
                border-radius: 12px;
              }
              .icon {
                cursor: pointer;
              }

              /* TEXT */
              .footer-col p {
                font-size: 14px;
                line-height: 1.7;
                color: #ffffff;
                font-weight: 500;
              }

              /* HEADINGS */
              .footer-col h3 {
                font-size: 16px;
                margin-bottom: 18px;
                color: #ffffff;
                font-weight: 600;
                letter-spacing: 0.5px;
              }

              /* LINKS */
              .footer-col ul {
                list-style: none;
                padding: 0;
              }

              .footer-col ul li {
                margin-bottom: 12px;
              }

              .footer-col ul li a {
                text-decoration: none;
                color: #ffffff;
                font-size: 14px;
                font-weight: 500;
                transition: all 0.25s ease;
              }

              .footer-col ul li a:hover {
                color: #ffffff;
                transform: translateX(4px);
              }

              /* CONTACT FIX (your main issue) */
              .footer-col-contact {
                display: flex;
                flex-direction: column;
                gap: 14px;
                max-width: 260px;
              }

              .contact-container {
                display: flex;
                flex-direction: column;
                gap: 15px;
              }

              .contact-itemf {
                display: grid;
                grid-template-columns: 40px 1fr;
                align-items: start;
                column-gap: 12px;
              }

              .contact-itemf span {
                font-size: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .contact-itemf p {
                margin: 0;
                text-decoration: none;
                // color: inherit;
              }

              .contact-itemf a,
              .contact-itemf a:hover,
              .contact-itemf a:focus,
              .contact-itemf a:active {
                text-decoration: none;
                color: inherit;
              }

              /* SOCIAL ICONS (premium size) */
              /* Social Icons Container */
              .social-icons {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 18px;
                padding: 12px 0;
              }

              /* Each Social Link Circle */
              .social-icons a {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                background: rgba(255, 255, 255, 0.12);
                display: flex;
                align-items: center;
                justify-content: center;
                text-decoration: none;
                transition: all 0.3s ease;
                overflow: visible; /* Ensures icons are not clipped */
              }

              /* Icon Styling */
              .social-icons a svg {
                font-size: 28px;
                line-height: 1;
                display: block;
                flex-shrink: 0;
                color: #ffffff;
              }

              /* Hover Effect */
              .social-icons a:hover {
                transform: translateY(-3px) scale(1.08);
                background: rgba(255, 255, 255, 0.22);
                box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
              }

              /* Optional Brand Colors on Hover */
              .social-icons a:nth-child(1):hover svg {
                color: #1877f2; /* Facebook */
              }

              .social-icons a:nth-child(2):hover svg {
                color: #e4405f; /* Instagram */
              }

              .social-icons a:nth-child(3):hover svg {
                color: #25d366; /* WhatsApp */
              }

              .social-icons a:nth-child(4):hover svg {
                color: #0a66c2; /* LinkedIn */
              }

              /* Mobile Responsive */
              @media (max-width: 768px) {
                .social-icons {
                  gap: 14px;
                }

                .social-icons a {
                  width: 50px;
                  height: 50px;
                }

                .social-icons a svg {
                  font-size: 24px;
                }
              }
              /* DEV BUTTON (premium glass style) */
              .dev-btn {
                margin-top: 15px;
                display: inline-block;
                padding: 8px 14px;
                border-radius: 999px;
                font-size: 13px;
                color: #fff;
                text-decoration: none;
                background: rgba(255,255,255,0.08);
                backdrop-filter: blur(6px);
                border: 1px solid rgba(255,255,255,0.2);
                transition: 0.3s;
              }

              /* ✨ Hover effect */ 
              .dev-btn:hover { 
              transform: translateY(-2px) scale(1.03); 
              box-shadow: 0 8px 20px rgba(0,0,0,0.25); 
              }

              /* FOOTER BOTTOM */
              .footer-bottom {
                margin-top: 40px;
                text-align: center;
                font-size: 13px;
                color: #feffff;
                border-top: 1px solid rgba(255,255,255,0.15);
                padding-top: 18px;
              }
              .footer-col:first-child {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
              }
                .footer-col:first-child p {
                max-width: 280px;
                line-height: 1.8;
              }

              /* TABLET */
              @media (max-width: 900px) {
                .footer-container {
                  grid-template-columns: repeat(2, minmax(180px, 1fr));
                }
              }

              /* MOBILE */
              @media (max-width: 600px) {
               .footer-col {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                }
                .footer-container {
                  grid-template-columns: 1fr;
                  text-align: center;
                }

                .footer-col-contact {
                  align-items: center;
                  max-width: 100%;
                }

                .contact-itemf {
                  justify-content: center;
                  text-align: left;
                }

                .social-icons {
                  justify-content: center;
                }
              }
      `}</style>
    </footer>
  );
}
